$(document).ready(function () {
  // grab the initial top offset of the navigation

  $('.accordion-container .set > a').on('click', function (event) {
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).siblings('.contenta').slideUp(200);
      $('.set > a i').removeClass('fa-minus').addClass('fa-plus');
    } else {
      $('.set > a i').removeClass('fa-minus').addClass('fa-plus');
      $(this).find('i').removeClass('fa-plus').addClass('fa-minus');
      $('.set > a').removeClass('active');
      $(this).addClass('active');
      $('.contenta').slideUp(200);
      $(this).siblings('.contenta').slideDown(200);
    }
  });

  $('.hamburger-button').on('click', function () {
    console.log('clicked');
    $('body').addClass('active-overlay');
    $('#navbar-mobile').addClass('show');
  });

  // Sticky header
  var $header = $('.header');
  if ($header.length && $header.hasClass('keep-this')) {
    var stickyNavTop = $header.offset().top;
    var headerHeight = $header.outerHeight();

    function stickyNav() {
      if ($(window).scrollTop() > stickyNavTop) {
        if (!$header.hasClass('is-sticky')) {
          $header.addClass('is-sticky');
          // Add padding to prevent content jump when header becomes fixed
          $('body').css('padding-top', headerHeight + 'px');
        }
      } else {
        if ($header.hasClass('is-sticky')) {
          $header.removeClass('is-sticky');
          $('body').css('padding-top', '');
        }
      }
    }

    stickyNav();
    $(window).scroll(function () {
      stickyNav();
    });

    // Recalculate header height on resize
    $(window).resize(function () {
      headerHeight = $header.outerHeight();
      if ($header.hasClass('is-sticky')) {
        $('body').css('padding-top', headerHeight + 'px');
      }
    });
  }

  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('#scroll').fadeIn();
    } else {
      $('#scroll').fadeOut();
    }
  });

  $('#scroll').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 600);
    return false;
  });

  // Open verticals menu

  $('.overlay-close-menu').on('click', function () {
    $('body').removeClass('active-overlay');
    $('#navbar-mobile').removeClass('show');
  });

  // Tab products
  var _collection = $('.section-tab-products .nav-item a').data('collection');
  console.log(_collection);
  // $(".section-tab-products #" + _collection).addClass("show");
});

$(window).load(function () {
  $('body').addClass('complete');

  // $('.grid').masonry({
  //     // set itemSelector so .grid-sizer is not used in layout
  //     itemSelector: '.grid-item',
  //     // use element for option
  //     // columnWidth: '.grid-sizer',
  //     percentPosition: true
  // })
});
